<template>
    <v-dialog :width="700" :value="true">
        <v-card style="height: 500px" class="d-flex flex-column">

            <div class="d-flex align-center" >

                <v-btn
                        icon
                        class="display--text mx-2"
                        @click="$emit('close', true)"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>

                <div class="subtitle-1 flex-grow-1 mt-0">
                    Configure Annexure
                </div>


                <v-menu offset-y>
                    <template #activator="{on}">
                        <v-btn
                                icon
                                color="primary"
                                class="mr-2 mt-1"
                                v-on="on"
                        >
                            <v-icon>mdi-information</v-icon>
                        </v-btn>
                    </template>
                    <v-list dense>
                        <v-list-item v-for="(item, i) in helpItems" :key="i" @click="copy(item)">
                            <v-list-item-content>
                                <v-list-item-title>{{item.title}}</v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-action class="py-0 my-0">
                                <v-btn
                                        icon
                                        small
                                        color="secondary"
                                >
                                    <v-icon small>mdi-content-copy</v-icon>
                                </v-btn>
                            </v-list-item-action>
                        </v-list-item>
                    </v-list>
                </v-menu>



            </div>

            <div style="position: absolute; width: 100%; height: 100%;" class="d-flex align-center justify-center" v-if="loading">
                <v-progress-circular
                        v-if="true"
                        :size="50"
                        :width="3"
                        color="primary"
                        indeterminate
                />
            </div>

            <div
                    v-if="show"
            >
                <v-text-field
                        v-model="description"
                        label="Annexure Name"
                        outlined
                        class="ma-1"
                        hide-details
                        placeholder="Annexure Name"
                        persistent-placeholder
                        dense
                ></v-text-field>
            </div>

            <Editor
                    v-if="show"
                    api-key="rmmqi59eb2ord4m4pb14jprluc3p5yalfjevkjjl1ue9ey7c"
                    :init="{plugins: 'lists link image table '}"
                    class="flex-grow-1"
                    v-model="body"
                    ref="tiny"
                    :style="{display: loading ? 'none' : 'null'}"
            />
        </v-card>
    </v-dialog>
</template>

<script>

import Editor from '@tinymce/tinymce-vue'
import {copyText} from '@/core/codeFunctions'

export default {
    components: {
        Editor,
    },
    props: {
        annexure: Object
    },
    data() {
        return {
            show: false,
            model: "",
            document,
            helpItems: [
                {title: "Contract Date", value: "[Date]"},
                {title: "Team Name", value: "[Team Name]"},
                {title: "Employees Table", value: "[Employee Table]"},
            ],
            preventLeak: null,
            loading: true
        }
    },
    created() {
        this.model = this.defaultStr
        setTimeout(() => {
            this.show = true
        }, 500)
        this.preventLeak = this.checkInit()
    },
    beforeDestroy() {
        try {
            clearTimeout(this.preventLeak)
        } catch (e) {
            console.log(e)
        }
    },
    methods: {

        checkInit() {
            return setTimeout(() => {
                try {
                    if (!this.$refs.tiny.initialized)
                        this.preventLeak = this.checkInit()
                    else
                        this.loading = false
                } catch (e) {
                    this.preventLeak = this.checkInit()
                }
            }, 100)
        },

        copy(item) {
            copyText(document, item.value)
            this.$snack.info(`${item.title} Variable Copied`)
        },
        test() {

        }
    },
    computed: {
        description: {
            get() {
                return this.annexure.description
            },
            set(val) {
                this.$emit("input", {
                   description: val,
                   body: this.body
                })
            }
        },
        body: {
            get() {
                return this.annexure.body
            },
            set(val) {
                this.$emit("input", {
                    description: this.description,
                    body: val
                })
            }
        }
    }
}
</script>

<style scoped>

</style>